/* eslint no-underscore-dangle: 0 */

import template from './platformPitch.html';

function PlatformPitchController($translate) {
  const calculateAvailablePlatforms = (pitchedPlatforms) => {
    this.formPlatforms = this.platforms
      .reduce((acc, platform) => {
        const existingIndex = pitchedPlatforms.findIndex(plat =>
          (plat.website === platform.website && plat.path === platform.path));

        if (existingIndex < 0 && platform.website === (this.selectedWebsite || {})._id) {
          const currentSite = this.sites.find(site => site._id === platform.website)
            || { display_name: $translate.instant('UNKNOWN') };

          acc.push({
            active: false,
            name: platform.title,
            id: platform.path,
            site: platform.website,
            siteName: currentSite.display_name
          });
        }

        return acc;
      }, []);
  };

  this.toggleWebsite = (id) => {
    this.selectedWebsite = this.sites.find(site => site._id === id);
    calculateAvailablePlatforms(this.excludedTargets);
  };

  this.togglePlatform = (platform, deleteIcon = false) => {
    if (deleteIcon) {
      const current = this.platformList
        .find(plat => plat.id === platform.id && plat.site === platform.site);
      current.active = false;
    }

    if (platform.active) {
      this.platformList.push(platform);
    } else {
      const index = this.platformList
        .findIndex(plat => plat.id === platform.id && plat.site === platform.site);
      this.platformList.splice(index, 1);
    }

    this.toggleOneTarget({ target: platform });
  };

  this.$onInit = () => {
    this.note = {};
    this.platformList = [];
    const [firstSite] = this.sites;
    this.selectedWebsite = this.sites.find(site => site.is_default_website)
      || firstSite;

    calculateAvailablePlatforms(this.excludedTargets);
  };

  this.$onChanges = (changes) => {
    const { excludedTargets } = changes;

    if (this.selectedWebsite && excludedTargets && Array.isArray(excludedTargets.currentValue)) {
      calculateAvailablePlatforms(excludedTargets.currentValue);

      if (excludedTargets.currentValue.length > excludedTargets.previousValue.length) {
        this.platformList = [];
      }
    }
  };
}

PlatformPitchController.$inject = ['$translate'];

const platformPitch = {
  template,
  bindings: {
    excludedTargets: '<',
    formData: '<',
    platforms: '<',
    sites: '<',
    toggleOneTarget: '&'
  },
  controller: 'PlatformPitchController'
};

export default function (ngModule) {
  ngModule.component('platformPitch', platformPitch);
  ngModule.controller('PlatformPitchController', PlatformPitchController);
}
